export default __webpack_public_path__ + "static/media/google-analytics.bc68ca64.svg";